import { Typography } from "antd";
import React from "react";

import { BottomIndentWrapper } from "../../../spaces";
import intl from "../../../utils/intl";
import Spinner from "../../Spinner";
import SavingProps from "./props";

const Saving: React.FC<SavingProps> = (props: SavingProps) => {
  return (
    <>
      <div>
        <BottomIndentWrapper>
          <Typography.Title level={5}>
            {intl.formatMessage(props.messages.saving)}
          </Typography.Title>
        </BottomIndentWrapper>
      </div>
      <Spinner />
    </>
  );
};

export default Saving;
